<template>
  <div class="attendee-avatar">
    <div class="avatar-wrap" :style="aws">
      <div class="avatar" :style="{margin: iconMargin}" v-for="(item, i) in member" :key="i">
        <div class="avatar-img" v-if="item">
          <span class="founder-icon" v-if="item.isFounder">拼主</span>
          <img width="100%" height="100%" :src="item.headIcon || defaultAvatar" alt="" />
        </div>
        <div class="empty-avatar" v-else>
          <img :src="emptyAvatar" width="100%" height="100%"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const DEFAULTWIDTH = 45
export default {
  props: {
    member: {
      type: Array,
    },
    aws: {
      type: String,
    },
    'icon-margin': {
      type: String,
    }
  },
  data() {
    return {
      defaultAvatar: require('../../image/user/head.png'),
      emptyAvatar: require('../../image/global/headIcon.png')
    }
  },
  computed: {
    // maxWidth() {
    //   return (parseInt(this.iconMargin || 10) * 2 + DEFAULTWIDTH) * this.member.length + 'px'
    // }
  },
  mounted() {
  }
}
</script>

<style lang="less" scoped>
  @import url('../../stylesheet/variable.less');
  .attendee-avatar {
    height: 85px;
    width: 100%;
    padding: 10px;
    overflow-x: auto;
    overflow-y: hidden;
    .avatar-wrap {
      margin: 0 auto;
      max-width: 325px;
      display: flex;
      justify-content: center;
      .avatar {
        position: relative;
        width: 47px;
        min-width: 47px;
        height: 47px;
        float: left;
        margin: 10px 7.5px;
        @media screen and (max-width: 374px) and (min-width: 320px) {
          margin: 4px;
        }
        .avatar-img {
          width: 100%;
          height: 100%;
          overflow: hidden;
          border-radius: 23px;
          border: #ededed solid 1px;
          .founder-icon {
            position: absolute;
            top: -7px;
            left: 1px;
            width: 26px;
            height: 14px;
            color: #fff;
            border-radius: 50px;
            border: solid #fff 1px;
            font-size: 9px;
            line-height: 14px;
            text-align: center;
            background: @orange;
          }
        }
        .empty-avatar {
          width: 45px;
          height: 45px;
          line-height: 45px;
          text-align: center;
          color: @lightSliver;
          // border-radius: 23px;
          // border: @lightSliver 1px dashed;
          @media screen and (max-width: 374px) and (min-width: 320px) {
            // line-height: 34px
          }
        }
      }
    }
  }
</style>
